import { render } from "./riskMap.vue?vue&type=template&id=3ab6a0ea&scoped=true"
import script from "./riskMap.vue?vue&type=script&lang=js"
export * from "./riskMap.vue?vue&type=script&lang=js"

import "./riskMap.vue?vue&type=style&index=0&id=3ab6a0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab6a0ea"]])

export default __exports__